<template>
  <div v-if="loading" class="loading-container">
    <v-progress-circular indeterminate color="primary" size="64" width="6" />
  </div>
</template>

<script>
export default {
  computed: {
    loading() {
      return this.$store.state.loading; // Mengontrol status loading
    },
  },
};
</script>

<style scoped>
.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.7); /* Latar belakang opsional */
  z-index: 9999;
}

.v-progress-circular {
  animation: spin 1s linear infinite;
}

.v-progress-circular__overlay {
  stroke-dasharray: 80; /* Atur panjang garis sesuai kebutuhan */
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
